var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#002B2B",
  d: "M9.4 2 9 0H0v17h2v-7h5.6l.4 2h7V2zm3.6 8H9.64l-.4-2H2V2h5.36l.4 2H13z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.66 9.987c-.002-.004-.095-.456-.206-1.004l-.202-.996-3.614-.008-3.615-.008V2.023l2.664.007 2.663.008.197.99.197.988h5.24v5.979h-1.66c-.914 0-1.663-.004-1.665-.008",
  style: {
    fill: "gray",
    fillRule: "evenodd",
    strokeWidth: 0.0150977
  }
}));
export { SvgFlagGray as ReactComponent };
export default __webpack_public_path__ + "cb5894908f8fdcc54d5d94bed8c3b7c9.svg";